<template>
  <Modal v-model="model" title="短信发送" sticky reset-drag-position @on-cancel="cancel" footer-hide :mask="false" draggable scrollable class="send_message insert_edit_dept">
    <div class="pop_top">
      <div class="dept_edit_input">
        <div class="font_style_set">发送方式:</div>
        <Select v-model="sendType" placeholder="请选择发送模板" title="发送模板">
          <Option v-for="(option, index) in sendTypeList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
      </div>
      <div class="dept_edit_input">
        <div class="font_style_set">模板内容:</div>
        <Select v-model="msgTemplate" placeholder="请选择发送模板" clearable title="发送模板" @on-change="handleTemplate">
          <Option v-for="(option, index) in msgTemplateList" :value="option.id" :key="index">{{option.tittle}}</Option>
        </Select>
      </div>
      <div class="dept_edit_input">
        <div class="font_style_set"><span style="color: red">*</span>发送内容:</div>
        <Input v-model="content" type="textarea" :autosize="{minRows: 5,maxRows: 100}"/>
      </div>
    </div>
    <div class="btn_template">
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" class="submit_btn" @click="sendMessage()">发送</Button>
    </div>
  </Modal>
</template>

<script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    export default {
      name: "SendGroupMessagePop",
      mixins:[publicFunClass],
      props:{
        showSendGroupMessage:Boolean,
        checkIds:Array,
        queryParam:Object
      },
      data(){
        return {
          model:false,
          msgTemplate:'',
          msgTemplateList:[],
          content:'',
          sendType:'0',
          sendTypeList:[{'id':'0','name':'按选中结果发送'},{'id':'1','name':'按搜索结果发送'}],
        }
      },
      methods:{
        cancel:function(){
          this.$emit("closeSendGroupMessage",false);
        },
        sendMessage:function () {
          if(!this.content){
            this.$Modal.info({
              title:'提示',
              content:"发送内容不能为空"
            });
            return false;
          }
          let that=this;
          let param={
            id:"",
            type:this.sendType,
            content:this.content,
            msgTemplate:this.msgTemplate,
            customerScope:this.queryParam.customerScope,
            customerState:this.queryParam.customerState,
            journalType:"客户管理=>全部客户=>短信群发",
            menuId:"1_2-11"
          };
          if(this.sendType=='0'){
            if(this.checkIds.length==0){
              this.$Modal.info({
                title:'提示',
                content:"请选择发送人"
              });
              return false;
            }
            if(this.checkIds.length>1000){
              this.$Modal.info({
                title:'提示',
                content:"短信群发不能超过1000人"
              });
              return false;
            }
            param.id=this.checkIds.toString();
          }else {
            this.$set(this.queryParam, 'type', this.sendType);
            this.$set(this.queryParam, 'content', this.content);
            this.$set(this.queryParam, 'msgTemplate', this.msgTemplate);
            param = this.queryParam;
          }
          this.$http.post("customer/doGroupSendMsg.json",param) .then(function (res) {
            let result=res.data.flag;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            that.$Message.info("群发短信成功");
            that.$emit("closeSendGroupMessage",true);
          });
        },
        handleTemplate:function(){
          for(let i=0;i<this.msgTemplateList.length;i++){
            let id=this.msgTemplateList[i].id;
            let content=this.msgTemplateList[i].content;
            if(id==this.msgTemplate){
              this.content=content;
            }
          }
        },
        initSearch:function () {
          let that=this;
          let param={
            tittle:"",
            createTime:"",
            pageNum:"",
            pageSize:"",
            journalType:"null",
            menuId:"null"
          };
          this.$http.post("message/toTemplateIndex.json",param) .then(function (res) {
            let result=res.data.flag;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            that.msgTemplateList=res.data.obj.list.content;
          });
        }
      },
      watch:{
        showSendGroupMessage:function () {
          this.model=this.showSendGroupMessage;
          this.msgTemplate="";
          this.content="";
          if(this.showSendGroupMessage){
            this.sendType="0";
            this.initSearch();
          }
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/customerMange/SendGroupMessagePop.vue